module.exports = __webpack_public_path__ + "70ae9766440aecd8f1cb21268c27e0a0.svg";